import React from 'react';

import LookupPicker from './lookup_picker';
import { FIELD_ERROR_TEXT } from './adapters';
import { category_options } from './form_logic';
import { LIMITS } from './params';
import { fmt } from '../format';

/*
 * PROD-7828 R8 — the fields shared by the add form and the edit modal (teacher and payment month are
 * NOT here: both are immutable on edit, Q13). Presentational only; every rule lives in form_logic.js.
 * id_prefix keeps the two sets of ids apart: the add form and the edit modal can be open together.
 */
const err_text = (errors, field) =>
  errors[field] ? FIELD_ERROR_TEXT[errors[field]] || errors[field] : '';

const EntryFields = ({
  id_prefix,
  form,
  set_field,
  errors,
  categories,
  limits,
  search_sessions,
  session_disabled
}) => {
  const options = category_options(categories);
  const id = (field) => `${id_prefix}-${field}`;
  return (
    <>
      <div className="tp-field-2">
        <div className="tp-field">
          <label htmlFor={id('category')}>Category</label>
          <select
            id={id('category')}
            className="tp-select"
            value={form.category}
            onChange={(e) => set_field('category', e.target.value)}
          >
            <option value="">Select a category</option>
            {options.map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </select>
          {err_text(errors, 'category') ? (
            <span className="tp-err">{err_text(errors, 'category')}</span>
          ) : null}
        </div>
        <div className="tp-field">
          <label htmlFor={id('amount')}>Amount (₹)</label>
          <input
            id={id('amount')}
            className="tp-input"
            inputMode="decimal"
            value={form.amount}
            onChange={(e) => set_field('amount', e.target.value)}
            placeholder="0"
          />
          <span className="tp-hint">
            Payments to the teacher only — deductions are entered in Penalties. Max{' '}
            {fmt(limits.max_entry_inr)}.
          </span>
          {err_text(errors, 'amount') ? (
            <span className="tp-err">{err_text(errors, 'amount')}</span>
          ) : null}
        </div>
      </div>

      <div className="tp-field-2">
        <div className="tp-field">
          <label htmlFor={id('date')}>Entry date (IST)</label>
          <input
            id={id('date')}
            type="date"
            className="tp-input"
            value={form.entry_date}
            onChange={(e) => set_field('entry_date', e.target.value)}
          />
          {err_text(errors, 'entry_date') ? (
            <span className="tp-err">{err_text(errors, 'entry_date')}</span>
          ) : null}
        </div>
        <div className="tp-field">
          <label htmlFor={id('time')}>Entry time (IST, optional)</label>
          <input
            id={id('time')}
            type="time"
            className="tp-input"
            value={form.entry_time}
            onChange={(e) => set_field('entry_time', e.target.value)}
          />
          <span className="tp-hint">Defaults to 12:00 AM IST.</span>
        </div>
      </div>

      <div className="tp-field">
        <label htmlFor={id('note')}>Note — shown to the teacher in the payment email</label>
        <textarea
          id={id('note')}
          className="tp-textarea"
          maxLength={LIMITS.NOTE_MAX_LEN}
          value={form.note}
          onChange={(e) => set_field('note', e.target.value)}
          placeholder="What this payment is for"
        />
        {err_text(errors, 'note') ? (
          <span className="tp-err">{err_text(errors, 'note')}</span>
        ) : null}
      </div>

      <div className="tp-field-2">
        <div className="tp-field">
          <label htmlFor={id('ref')}>Reference id (optional)</label>
          <input
            id={id('ref')}
            className="tp-input"
            maxLength={LIMITS.REFERENCE_ID_MAX_LEN}
            value={form.reference_id}
            onChange={(e) => set_field('reference_id', e.target.value)}
          />
          {err_text(errors, 'reference_id') ? (
            <span className="tp-err">{err_text(errors, 'reference_id')}</span>
          ) : null}
        </div>
        <LookupPicker
          id={id('session')}
          name="session"
          label="Session (optional)"
          placeholder="Search this month's sessions"
          min_chars={0}
          value_text={form.related_session_label}
          disabled={session_disabled}
          disabled_hint="Choose a teacher first."
          search={search_sessions}
          option_key={(s) => s.session_uuid}
          render_option={(s) => (
            <span>
              <b>{s.start_time_ist}</b> · {s.type} · {s.duration_mins} mins · {s.status}
              {s.student_name ? ` · ${s.student_name}` : ''}
            </span>
          )}
          on_pick={(s) => {
            set_field('related_session_uuid', s.session_uuid);
            set_field(
              'related_session_label',
              `${s.start_time_ist} · ${s.type} · ${s.session_uuid}`
            );
          }}
          on_clear={() => {
            set_field('related_session_uuid', '');
            set_field('related_session_label', '');
          }}
        />
      </div>
    </>
  );
};

export default EntryFields;
